(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function handleAutounfilter() {
		// Stops the query if no results were found and creates a new query where the filters are removed.
		// Should be added after spellchecking (because autocorrections should be applied first).
		return function autounfilterHandler(data, configuration, callback) {
			// Only unfilter automatically if no results
			if(data.resultCount) {
				return callback();
			}

			// No filters set to begin with. Abort.
			if(!configuration.requiredfields) {
				return callback();
			}

			var processor = this.processor;
			// Clear filters and re-trigger search
			var update = {
				filter: {},
				subsearch: true,
				previousFilter: configuration.filter
			};
			var config = search.util.extend({}, configuration.inputConfig, update);
			processor.track('automaticFilterRemoval', search.util.extend({}, configuration, update));

			this.abort(true);
			processor.process(config);
		};
	}

	function setUp(processor, autounfilterHandler, weight) {
		weight = weight || 110;
		processor.usePost(autounfilterHandler||handleAutounfilter(), weight);
	}

	var plugins = search.plugins = search.plugins || {};
	var filtering = plugins.filtering = plugins.filtering || {};

	filtering.handleAutounfilter = handleAutounfilter;
	filtering.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/filtering.js
// module id = 54
// module chunks = 0